import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      contentShow: false,
      imgShow: false,
      fileShow: false,
      tableData: [],
      options: [],
      imgLeft: require('@/assets/img/iconAvatar-1.png'),
      imgRight: require('@/assets/img/powerchina-mini.png'),
      fileRealUrl: require('@/assets/img/weizhang.png'),
      dialog: false,
      dialogV2: false,
      title: "",
      srcList: [],
      fileList: [],
      imgList: [],
      pId: "",
      form: {}
    };
  },
  methods: {
    show: function show(row, sendType) {
      var _this = this;
      this.pId = row.pId;
      this.msgId = row.msgId;
      // {{h7}}/material-message/message-status-diff-flag/1792809774128173056
      this.$get("/material-message/message-status-diff-flag/".concat(this.pId)).then(function (res) {
        if (res.obj == true) {
          _this.dialogV2 = true;
        } else {
          _this.removeImg();
          _this.removeFile();
          _this.form = {
            bidId: '',
            companyIds: [],
            content: '',
            fileName: '',
            fileSuffix: '',
            fileUri: '',
            sendType: sendType
          }, _this.tableData = [];
          _this.dialog = true;
          _this.getTableData();
          _this.getMaterialEntp();
        }
      });
    },
    getDisType: function getDisType() {
      if (this.form.content) {
        this.contentShow = false;
        this.imgShow = true;
        this.fileShow = true;
        this.form.fileSuffix = '文字';
      } else {
        this.contentShow = false;
        this.imgShow = false;
        this.form.fileSuffix = '';
        this.fileShow = false;
      }
    },
    getTableData: function getTableData() {
      var _this2 = this;
      this.$get("/material-message/message-id/".concat(this.pId)).then(function (res) {
        _this2.tableData = res.obj;
        var reviewStatus = _this2.tableData[0].reviewStatus;
        if (reviewStatus == 'REVIEW_BEFORE') {
          _this2.title = '报价截止前';
        } else if (reviewStatus == 'REVIEWING') {
          _this2.title = '评审中';
        } else if (reviewStatus == 'REVIEW_AFTER') {
          _this2.title = '送货中';
        } else {
          _this2.title = '';
        }
        _this2.form.bidId = _this2.tableData[0].bidId;
      });
    },
    // 查询沟通过的企业或报价企业
    getMaterialEntp: function getMaterialEntp() {
      var _this3 = this;
      this.$get("/material-message/entp/message-id/".concat(this.pId)).then(function (res) {
        _this3.options = res.obj;
        _this3.options.forEach(function (item) {
          _this3.form.companyIds.push(item.companyId);
        });
      });
    },
    submitv2: function submitv2() {
      var _this4 = this;
      this.$put('/jpush/updateUnRead?msgId=' + this.msgId).then(function (res) {
        _this4.$emit('confirm');
      });
      this.dialogV2 = false;
    },
    submit: function submit(row) {
      var _this5 = this;
      if (row) {
        this.form.fileSuffix = '文字';
        this.form.content = row;
        this.form.fileName = '';
        this.form.fileUri = '';
      }
      if (!this.form.fileSuffix) {
        this.$message.error("请填写提问或答疑内容！");
        return;
      }
      if (this.form.companyIds.length == 0) {
        this.$message.error("请选择企业！");
        return;
      }
      this.$post('/material-message', this.form).then(function (res) {
        _this5.$message.success("回复成功");
        _this5.dialog = false;
        _this5.$emit('confirm');
        _this5.$put('/jpush/updateUnRead?msgId=' + _this5.msgId).then(function (res) {});
      });
    },
    // 文件上传
    uploadFile: function uploadFile(file) {
      var _this6 = this;
      var fileName = file.raw.name;
      if (fileName) {
        var type = fileName.substring(file.name.lastIndexOf('.') + 1);
        if (type == 'doc' || type == 'docx' || type == 'pdf') {
          this.$postUpload('/util/upload', {
            file: file.raw,
            type: 'bid'
          }).then(function (res) {
            _this6.form.fileUri = res.obj.key;
            _this6.form.fileName = fileName;
            _this6.form.fileSuffix = '文件';
            _this6.contentShow = true;
            _this6.imgShow = true;
            _this6.fileShow = false;
          });
        } else {
          this.$message.error('上传文件只能是 doc或docx pdf 格式!');
          this.fileList = [];
        }
      } else {
        this.$message.error('上传文件不正确!');
        this.fileList = [];
      }
    },
    removeFile: function removeFile() {
      this.fileList = [];
      this.form.fileUri = '';
      this.form.fileName = '';
      this.form.fileSuffix = '';
      this.contentShow = false;
      this.imgShow = false;
      this.fileShow = false;
    },
    //图片的上传
    uploadImg: function uploadImg(file) {
      var _this7 = this;
      var fileName = file.raw.name;
      if (fileName) {
        var type = fileName.substring(file.name.lastIndexOf('.') + 1);
        if (type == 'jpg' || type == 'png') {
          this.$postUpload('/util/upload', {
            file: file.raw,
            type: 'bid'
          }).then(function (res) {
            _this7.form.fileUri = res.obj.key;
            _this7.form.fileName = fileName;
            _this7.form.fileSuffix = '图片';
            _this7.contentShow = true;
            _this7.imgShow = false;
            _this7.fileShow = true;
          });
        } else {
          this.$message.error('上传文件只能是 jpg png 格式!');
          this.imgList = [];
        }
      } else {
        this.$message.error('上传文件不正确!');
        this.imgList = [];
      }
    },
    removeImg: function removeImg() {
      this.imgList = [];
      this.form.fileUri = '';
      this.form.fileName = '';
      this.form.fileSuffix = '';
      this.contentShow = false;
      this.imgShow = false;
      this.fileShow = false;
    }
  }
};